import PropTypes from 'prop-types';
import { action, extendObservable } from 'mobx';
import { PolicyModalSectionProps } from '../PolicyModalStore';
import InputStore from '../../InputStore';
import FlagStore from '../../FlagStore';

export const FILE_SIZE_MIN_VALUE = 0;
export const DB_INT_MAX_VALUE = 2147483647;

const DEFAULT_VALUES = {
    maximumSizeAllowed: null,
    matchAllFileSize: false,
};

export default class FileSizeStore {
    static PropType = PropTypes.shape({
        maxFileSize: InputStore.PropType.isRequired,
        matchAllFileSize: FlagStore.PropType.isRequired,

        ...PolicyModalSectionProps,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class FileSizeStore */{
            maxFileSize: new InputStore({ onChangeHandler: this.onChangeHandler }),
            matchAllFileSize: new FlagStore(),

            originalValue: {},
        }, data);
    }

    setValue = action((value) => {
        value = { ...DEFAULT_VALUES, ...value };
        this.originalValue = value;
        this.matchAllFileSize.setValue(value.matchAllFileSize);
        this.maxFileSize.setValue(value.maximumSizeAllowed);
    });

    clear = () => {
        this.maxFileSize.setValue(DEFAULT_VALUES.maximumSizeAllowed);
        this.matchAllFileSize.setValue(DEFAULT_VALUES.matchAllFileSize);
    }

    // this handler allows an empty value or 'Natural' numbers in between range
    onChangeHandler = ({ target }) => {
        if (!target.value ||
            (target.value >= FILE_SIZE_MIN_VALUE
                && target.value <= DB_INT_MAX_VALUE
                && /^[0-9]+$/.test(target.value))) {
            this.maxFileSize.setValue(target.value);
        }
    };

    getValue = () => ({
        maximumSizeAllowed: this.maxFileSize.getValue(),
        matchAllFileSize: this.matchAllFileSize.getValue()
    });

    isEmpty = () => !this.matchAllFileSize.getValue() && !this.maxFileSize.value;

    hasChanged = () => this.matchAllFileSize.getValue() !== this.originalValue.matchAllFileSize
        || Number(this.originalValue.maximumSizeAllowed) !== Number(this.maxFileSize.getValue());
}
